import { RepositoryFactory } from "../../data/repositories/repositoryFactory";

const state = {
    recentBatches: [],
    selectedBatch: null,
    selectedBatchSummary: null,
    loading: false,
    error: null
};

const getters = {
    recentBatches: state => state.recentBatches,
    selectedBatch: state => state.selectedBatch,
    selectedBatchSummary: state => state.selectedBatchSummary,
    loading: state => state.loading,
    error: state => state.error
};

const actions = {
    async fetchRecentBatches({ commit }, count = 20) {
        commit("SET_LOADING", true);
        try {
            const response = await RepositoryFactory.get("provisionBatch").getRecentBatches(count);
            commit("SET_RECENT_BATCHES", response.data);
            commit("SET_ERROR", null);
        } catch (error) {
            commit("SET_ERROR", error.message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async fetchBatchDetails({ commit }, batchId) {
        commit("SET_LOADING", true);
        try {
            const response = await RepositoryFactory.get("provisionBatch").getBatchDetails(batchId);
            commit("SET_SELECTED_BATCH", response.data);
            commit("SET_ERROR", null);
        } catch (error) {
            commit("SET_ERROR", error.message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async fetchBatchAreaSummary({ commit }, batchId) {
        commit("SET_LOADING", true);
        try {
            const response = await RepositoryFactory.get("provisionBatch").getBatchAreaSummary(batchId);
            commit("SET_SELECTED_BATCH_SUMMARY", response.data);
            commit("SET_ERROR", null);
        } catch (error) {
            commit("SET_ERROR", error.message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    clearSelectedBatch({ commit }) {
        commit("SET_SELECTED_BATCH", null);
        commit("SET_SELECTED_BATCH_SUMMARY", null);
    },

    async downloadBatchSummary({ commit }, batchId) {
        const response = await RepositoryFactory.get("provisionBatch").downloadSummary(batchId);
        return response.data;
    },

    async downloadBatchEventIds({ commit }, batchId) {
        const response = await RepositoryFactory.get("provisionBatch").downloadEventIds(batchId);
        return response.data;
    },

    async downloadBatchDetailedReport({ commit }, batchId) {
        const response = await RepositoryFactory.get("provisionBatch").downloadDetailedReport(batchId);
        return response.data;
    }
};

const mutations = {
    SET_RECENT_BATCHES(state, batches) {
        state.recentBatches = batches;
    },
    SET_SELECTED_BATCH(state, batch) {
        state.selectedBatch = batch;
    },
    SET_SELECTED_BATCH_SUMMARY(state, summary) {
        state.selectedBatchSummary = summary;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
